import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';

@Component({
  selector: 'app-fabrication',
  templateUrl: './fabrication.component.html',
  styleUrls: ['./fabrication.component.scss']
})
export class FabricationComponent implements OnInit {

  hostName = GlobalComponent.hostName;

  constructor(private router :Router,private SEOService:SeoService) {window.scroll(0, 0); }

  ngOnInit(): void {
    this.SEOService.updateCanonicalUrl(this.hostName + '/fabrication');
  }
  signup()
  {
    this.router.navigate(['/login/signup']);

  }


}
